import React from 'react';
import PropTypes from 'prop-types';
import { Text } from 'react-orange-ui';

import ContactCard from '../../Contact/ContactCard';
import WordingService from '../../../services/WordingService';

const OtherContact = ({ onClick, text }) => (
  <div>
    <Text id="no-contact">
      {text}
    </Text>
    <ContactCard id='no-contact' icon="pack" contact={{contactView: WordingService.getWording('caption', 'otherMethod')}} onClick={onClick} />
  </div>
);

OtherContact.propTypes = {
  onClick: PropTypes.func.isRequired,
  text: PropTypes.string.isRequired,
};

export default OtherContact;
